import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeSearch from '../views/HomeSearch.vue'
import Main from '../views/Main.vue'
import store from '../store'

Vue.use(VueRouter)

  const routes = [
  {
    path: '*',
    name: 'Home',
    component: HomeSearch
  },
  {
    path: '/:glk/:zoneId',
    name: 'Main',
    component: Main
  }
]

const router = new VueRouter({
  routes
})

router.pushQuery = (query)=>{
  let newQuery = {...router.history.current.query,...query}
  Object.keys(newQuery).forEach((key)=>{
    if(newQuery[key]===null) delete newQuery[key]
    // else newQuery[key] = JSON.stringify(newQuery[key])
  })
  return router.push({ query: newQuery ,state: {from: 'linked-data'}}).catch(() => {})
}

router.beforeEach((to, from, next) => {
  if(to.query.shareURL){
    store.commit('setShareURL', to.query.shareURL)
  }
  if (to.query.fullPath) {
    router.push(to.query.fullPath)
  }
  else next()
})


export default router
